import * as React from 'react'

const css = (el: HTMLDivElement, obj: { [k: string]: string | number }) => {
  const style = Object.keys(obj).reduce((styles, key) => {
    return `${styles} ${key}: ${obj[key]};`
  }, "")

  el.setAttribute("style", style)
};

const MIN_DURATION = 150
const DURATION_MULTIPLYER = 1.5

type Snapshot = {
  currentHeight: number
}

interface AdjustHeightForContentProps {
  className?: string
  children?: React.ReactNode
}

export class AdjustHeightForContent extends React.Component<AdjustHeightForContentProps> {
  elRef = React.createRef<HTMLDivElement>()
  timer: any = undefined

  getSnapshotBeforeUpdate() {
    const el = this.elRef.current

    if (!el) {
      return null
    }

    const currentHeight = el.clientHeight
    return { currentHeight }
  }

  componentDidUpdate(_1: any, _2: any, snapshot: Snapshot) {
    const currentHeight = snapshot && snapshot.currentHeight
    const el = this.elRef.current;

    if (!el) {
      return
    }

    el.removeAttribute("style");
    const newHeight = el.clientHeight

    // No need to transition for the same height
    if (newHeight === currentHeight) {
      return
    }

    const duration =
      MIN_DURATION + Math.abs(newHeight - currentHeight) * DURATION_MULTIPLYER

    css(el, {
      height: `${currentHeight}px`,
      overflow: "hidden",
      transition: `height ${duration}ms ease-out`
    })

    // allow the transitional styles to be added before we change it
    setTimeout(() => {
      el.style.height = `${newHeight}px`
    }, 1)


    // Remove styling to allow for native resizing
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      el.removeAttribute("style")
    }, duration)

  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    return (
      <div className={this.props.className} ref={this.elRef}>
        {this.props.children}
      </div>
    )
  }
}
